import { Dayjs } from 'dayjs';
import { FC } from 'react';
import { FaArrowRight } from 'react-icons/fa';
import { Label } from '../../../../../../../components/label/label';
import s from './checking-time-input.module.css';
import { Input } from '../../../../../../../components/input/input';
import { MaskedInput } from '../../../../../../../components/input/masked-input';

const TIME_MASK = '__:__';

interface Props {
  label: string;
  date?: Dayjs;
  time?: Dayjs;
  newDate?: Dayjs;
  newTime?: string;
  name: string;
  onChange?: (name: string, value: string) => void;
  disabled?: boolean;
}

export const CheckingTimeInput: FC<Props> = (props) => {
  const { label, date, time, newDate, newTime, name, onChange, disabled } = props;

  return (
    <div className={s.feature}>
      <Label className={s.label}>{label}</Label>

      <div className={s.inputWrapper}>
        <div className={s.date}>{date?.isValid() ? date.format('DD.MM.YYYY') : ''}</div>
        <Input
          size="lg"
          className={s.input}
          name={name}
          disabled
          value={time?.isValid() ? time.format('HH:mm') : ''}
        />
      </div>

      <FaArrowRight />

      <div className={s.inputWrapper}>
        <div className={s.date}>{newDate?.isValid() ? newDate.format('DD.MM.YYYY') : ''}</div>
        <MaskedInput
          size="lg"
          className={s.input}
          name={`new_${name}`}
          value={newTime}
          mask={TIME_MASK}
          placeholder={TIME_MASK}
          onChange={(e) => onChange?.(`new_${name}`, e)}
          disabled={disabled}
        />
      </div>
    </div>
  );
};
